define('views/components/go_order/licenses',['require','views/base/collection_view','views/components/go_order/license_list','text!templates/base/collection.html'],function (require) {
  var BaseCollectionView = require("views/base/collection_view");
  var ListView = require("views/components/go_order/license_list");

  var temp = require("text!templates/base/collection.html");
  return BaseCollectionView.extend({
    template: _.template(temp),
    className: "grid-container go-order-licenses-grid-container",

    initialize: function () {
      this.listenTo(this.collection, "fetch_complete", this._onFetch);
    },

    onRender: function () {
      this.ListContainer.show(
        new ListView({
          collection: this.collection,
        })
      );
    },

    _onFetch: function () {
      var firstModal = this.collection.at(0);
      if (firstModal) {
        App.context.changePageTitle(firstModal.get("product"));
      }
    },
  });
});

